// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  ruleset: __t.string(),
  culture: __t.string(),
  displayName: __t.string(),
  meleeWeapon: __t.string(),
  shield: __t.string(),
  armor: __t.string(),
  rangedWeapon: __t.string(),
  mount: __t.string(),
  training: __t.string(),
};
